import { Box, MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import "react-toastify/dist/ReactToastify.css";
const EditStudy = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const studyData = useSelector((state) => state.Modal.val);

  const { data: sponsorInfo = [], refetch, } = useQuery({
    queryKey: ["sponsorInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/sponsorDropdown`
      );
      const data = await res.json();
      return data;
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();

    formData.append("study_no", studyData.study_no);
    formData.append("sponsor_id", data.sponsor_id);
    formData.append("study_code", data.study_code);
    formData.append("protocol_title", data.protocol_title);
    formData.append("astatus_fg", data.astatus_fg);

    fetch(
      `${process.env.REACT_APP_API_URL}/api/updateStudy`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Study Update Successful", {
            position: toast.POSITION.TOP_CENTER
          });
          refetch().then(() => {
            dispatch(handleEditClose());
          });
        } else if (data.duplicate === true) {
          toast.error("This study is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Box mb="20px">
          <TextField
            select
            defaultValue={studyData.sponsor_id}
            fullWidth
            size="small"
            label="Sponsor Name*"
            {...register("sponsor_id", {
              required: true,
            })}
          >
            {sponsorInfo.map((sponsor) => (
              <MenuItem key={Math.random()} value={sponsor.sponsor_id}>
                {sponsor.sponsor_name}
              </MenuItem>
            ))}
          </TextField>
          {errors?.sponsor_id?.type === "required" && (
            <ErrorMessage>Sponsor name is required</ErrorMessage>
          )}
        </Box>

        <Box mb="20px">
          <TextField
            defaultValue={studyData.study_code}
            size="small"
            fullWidth
            label="Study Code*"
            variant="outlined"
            {...register("study_code", { required: true })}
          />
          {errors?.study_code?.type === "required" && (
            <ErrorMessage>Study Code is required*</ErrorMessage>
          )}
        </Box>

        <Box mb="20px">
          <TextField
            defaultValue={studyData.protocol_title}
            size="small"
            fullWidth
            label="Protocol Title*"
            variant="outlined"
            {...register("protocol_title", { required: true })}
          />
          {errors?.protocol_title?.type === "required" && (
            <ErrorMessage>Protocol is required*</ErrorMessage>
          )}
        </Box>
        <Box>
          <TextField
            select
            defaultValue={studyData.astatus_fg}
            size="small"
            fullWidth
            label="Active Status"
            variant="outlined"
            {...register("astatus_fg", {
              // required: true
            })}
          >
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">Inactive</MenuItem>
          </TextField>
          {errors?.astatus_fg?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Update Study
          </ThemButton>
        )}
      </Box>
      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />
    </form>
  );
};

export default EditStudy;
